import { APIServices } from './axiosCommon';

export interface ComposterInsightRow {
  ts: string;
  totesLoaded: number;
  kgsLoaded: number;
  kgsOffloaded: number;
  timeLoading: number;
  timeOffloading: number;
  weightReduced: number;
  pileTemp: number | null;
  heatPadTemp: number | null;
  avgMoisture: number | null;
  pileLevel: number | null;
}

export interface ComposterInsightsResponse {
  machineId: string;
  from: string;
  to: string;
  rows: ComposterInsightRow[];
  totals: {
    totesLoaded: number;
    kgsLoaded: number;
    kgsOffloaded: number;
    weightReduced: number;
  };
}

export interface LifterInsightRow {
  ts: string;
  totesLoaded: number;
  kgsLoaded: number;
  timeLoading: number;
}

export interface LifterInsightsResponse {
  machineId: string;
  from: string;
  to: string;
  rows: LifterInsightRow[];
  totals: { totesLoaded: number; kgsLoaded: number; timeLoading: number };
}

export const insightsApi = {
  composter: (machineId: string, from: string, to: string) =>
    APIServices.get<{ success: boolean; data: ComposterInsightsResponse }>('/insights/composter', {
      params: { machineId, from, to },
    }),
  lifter: (machineId: string, from: string, to: string) =>
    APIServices.get<{ success: boolean; data: LifterInsightsResponse }>('/insights/lifter', {
      params: { machineId, from, to },
    }),
};
